import styled from "styled-components";

import theme from "config/theme";

export const Inner = styled.div`
  position: relative;
  text-align: center;
  width: 100%;
  outline: none;

  .slick-track {
    min-width: 100%;
  }

  .slick-slide {
    &:first-child {
      margin-left: 160px;
    }

    &:last-child {
      margin-right: 160px;
    }

    @media (max-width: ${theme.size.desktop}) {
      &:first-child {
        margin-left: 100px;
      }
    }

    @media (max-width: ${theme.size.tablet}) {
      &:first-child {
        margin-left: 50px;
      }

      &:last-child {
        margin-right: 50px;
      }
    }

    @media (max-width: ${theme.size.mobile}) {
      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
`;
